<template>
  <base-dialog
    width="700px"
    v-ps="'.el-dialog__body'"
    class="verify-sheet-data-dialog"
    :class="[{ 'no-bar': fullScreen }]"
    :visible.sync="visible"
    show-close
    @open="openEvent"
    @closed="refreshOutside"
  >
    <template v-slot:header>
      {{ verifyItem.name }}
      <template v-if="verifyIds && verifyIds.length">
        <el-tooltip class="item" effect="dark" placement="bottom" :disabled="dataOrder === 'first'">
          <div slot="content">
            上一条
            <br />
            快捷键(Alt ＋ ←)
          </div>
          <i
            class="el-icon-arrow-left icon-turn-page"
            :class="{ 'is-disabled': dataOrder == 'first' }"
            @click="openData('previous')"
          ></i>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          placement="bottom"
          :disabled="dataOrder === 'last' || verifyIds.length === 1"
        >
          <div slot="content">
            下一条
            <br />
            快捷键(Alt ＋ →)
          </div>
          <i
            class="el-icon-arrow-right icon-turn-page"
            :class="{ 'is-disabled': dataOrder == 'last' || verifyIds.length === 1 }"
            @click="openData('later')"
          ></i>
        </el-tooltip>
      </template>
    </template>
    <div class="body-wrapper">
      <el-collapse v-model="activeNames">
        <el-collapse-item v-if="basisData.length" title="基本信息" name="1">
          <field-item
            v-for="row in basisData"
            :key="row.id"
            :control="row"
            :string-value="row.value"
            @openDataDetail="openDataDetail"
            :from="from"
          ></field-item>
        </el-collapse-item>
        <el-collapse-item v-if="verifyData.length" title="审批数据" name="1">
          <field-item
            v-for="row in verifyData"
            :key="row.id"
            :control="row"
            :string-value="row.value"
            @openDataDetail="openDataDetail"
            :from="from"
          ></field-item>
        </el-collapse-item>
        <el-collapse-item v-if="allShowControls.length" title="审批内容" name="2">
          <div class="verify-content" v-if="showControls.length">
            <div class="data-detail">
              <field-item
                v-for="(control, index) in showControls"
                :key="index"
                :control="control"
                :value="getValue(control._cid)"
                :string-value="getValue(control._cid, 'string')"
              ></field-item>
            </div>
            <template v-if="verifyType === 'sheet' && tabs.length">
              <div class="ref-table">
                <ref-menu
                  ref="sideMenu"
                  :menu-list="tabs"
                  @select="selectMenu"
                  :active="curTab.name"
                  class="ref-menu"
                ></ref-menu>
                <div class="content-body">
                  <div class="sheet-table-wrap" :class="{ 'full-screen': fullScreen }">
                    <div class="operation">
                      <div style="display: flex">
                        <div v-if="fullScreen" class="sheet-name font-topic">{{ curTab.name }}</div>
                      </div>
                      <div class="ref-button-group">
                        <span @click="fullScreen = !fullScreen">
                          {{ fullScreen ? "退出全屏" : "全屏" }}
                        </span>
                      </div>
                    </div>
                    <ref-sheet-table
                      :data-ids="curTab.dataIds"
                      :ref-control="refControl"
                      :delete-visible="false"
                      :col-filter="false"
                      :show-btn-column="false"
                    ></ref-sheet-table>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </el-collapse-item>
        <el-collapse-item v-if="verifyItem.verifyItems.length > 0" title="审批建议" name="3">
          <ul class="tip">
            <li v-for="(item, idx) in verifyItem.verifyItems" :key="idx" class="tip-item">
              {{ item }}
            </li>
          </ul>
        </el-collapse-item>
        <el-collapse-item
          v-if="verifyProcess && verifyProcess.length > 0"
          title="审批进程"
          name="4"
        >
          <verify-process
            :process-info="verifyProcess"
            class="process"
            :class="hasEnd ? 'has-end' : 'no-end'"
            from="verify"
          ></verify-process>
        </el-collapse-item>
      </el-collapse>
    </div>
    <template v-slot:footer>
      <div class="verify-operation">
        <div>
          <el-checkbox
            v-if="verifyIds && verifyIds.length > 1 && allButton.includes('verify')"
            v-model="dealNext"
            @change="setDealNext"
          >
            审批下一条
          </el-checkbox>
        </div>
        <div>
          <base-button
            v-for="(btn, index) in buttonList"
            :key="index"
            @click="handleCommand(btn.command)"
            :type="btn.type"
          >
            {{ btn.title }}
          </base-button>
        </div>
      </div>
    </template>
    <verify-confirm-dialog
      from="verify"
      :sheet-id="curSheetDef.sheetId"
      :data-id="curSheetData.id"
      ref="verifyConfirmDialog"
      :tip="promptTitle"
      :verify="verifyItem"
      @submit="submit"
      :pass="pass"
    ></verify-confirm-dialog>
    <select-user-dialog
      v-if="verifyType === 'sheet'"
      required
      multiple
      :app-id="appId"
      ref="candidatesDialog"
      title="选择审批人员"
      @select="changeCandidates"
    ></select-user-dialog>
    <select-user-dialog
      v-else
      required
      multiple
      :project-id="task.projectId"
      ref="candidatesDialog"
      title="选择审批人员"
      @select="changeCandidates"
    ></select-user-dialog>
    <sheet-detail-dialog
      ref="sheetDetailDialog"
      :visible.sync="sheetDetailVisible"
      :data-id="sheetDataId"
      :app-id="appId"
      @data-changed="$emit('task-verified')"
    ></sheet-detail-dialog>
    <task-detail-dialog
      ref="taskDetailDialog"
      :task-id="taskId"
      :visible.sync="taskDetailVisible"
      @data-changed="$emit('task-verified')"
    ></task-detail-dialog>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import FieldItem from "@/components/Sheet/DetailDialog/DataDetail/FieldItem"
import { loadingService } from "@/utils/ui"
import * as TaskApi from "@/api/task"
import { getFrontSetting, getVerifyButtonList, getVerifyProcess, setFrontSetting } from "@/api/user"
import processMixin from "@/components/Sheet/DetailDialog/ProcessMixin"
import VerifyProcess from "@/components/Sheet/DetailDialog/VerifyProcess"
import SelectUserDialog from "@/components/SelectUserDialog"
import { getSheetDataForDetail } from "@/api/sheet/sheetData"
import { getSheet, getSheetDefForDetail } from "@/api/sheet/sheet"
import { decorateSheet } from "@/utils/sheet"
import { getTask } from "@/api/project/task"
import { getRefDataInfo } from "@/utils/task"
import RefMenu from "@/components/RefMenu"
import RefSheetTable from "@/components/UIComponents/SheetTable/RefSheetTable"
import { initUserData } from "@/utils/user"
import VerifyConfirmDialog from "@/components/VerifyConfirmDialog"

export default {
  name: "VerifySheetDataDialog",
  components: {
    VerifyConfirmDialog,
    RefSheetTable,
    RefMenu,
    SelectUserDialog,
    VerifyProcess,
    BaseButton,
    BaseDialog,
    FieldItem
  },
  props: {
    sheetDef: Object,
    sheetData: {
      type: Object,
      default: () => ({})
    },
    // 只有任务审核时,才传入
    taskInfo: Object,
    from: String,
    verifyIds: Array
  },
  provide() {
    return { dataInfo: this.dataInfo }
  },
  mixins: [processMixin],
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      visible: false,
      verifyItem: {
        verifyItems: []
      },
      pass: true,
      allProcess: [],
      verifyProcess: [],
      allButton: [],
      buttonList: [],
      sheetDataInfo: {},
      sheetDefInfo: {},
      taskDataInfo: {},
      sheetDetailVisible: false,
      taskDetailVisible: false,
      sheetDataId: "",
      appId: "",
      taskId: "",
      verifyType: "sheet",
      curTab: { name: "" },
      fullScreen: false, // 关联多条全屏
      refControl: {},
      dealNext: true,
      lastOperation: null,
      dataInfo: { dataId: "", appId: "" },
      sign: {},
      tabs: []
    }
  },
  computed: {
    user() {
      return this.$store.getters.userInfo
    },
    task() {
      return this.from === "todo" ? this.taskDataInfo : this.taskInfo
    },
    curSheetDef() {
      return this.from === "todo" ? this.sheetDefInfo : this.sheetDef
    },
    curSheetData() {
      return this.from === "todo" ? this.sheetDataInfo : this.sheetData
    },
    cidControlMap() {
      return this._.keyBy(this.controls || [], "_cid")
    },
    controls() {
      if (this.verifyType === "task")
        return (getRefDataInfo(this.task, this.curSheetDef)?.fields || []).map(c => c.control)
      return this.curSheetDef.controls
    },
    allShowControls() {
      if (this.verifyType === "task") {
        return this.controls || []
      }
      return (this.verifyItem.verifyContents?.map(item => item.cid) || [])
        .map(cid => this.cidControlMap[cid])
        .filter(t => t)
    },
    showControls() {
      if (this.verifyType === "task") return this.allShowControls
      return this.allShowControls.filter(control => !(control._type === "ref" && !control.oneFlag))
    },
    basisData() {
      if (this.verifyType === "sheet") return []
      let verifyResult = ""
      if (this._.keys(this.verifyItem).includes("pass")) {
        if (this.verifyItem.pass === true) verifyResult = "通过"
        else if (this.verifyItem.pass === false) verifyResult = "驳回"
      }
      if (this.verifyItem.status == "RECALLED") verifyResult = "撤回"
      return [
        {
          id: this.verifyItem.taskId,
          name: "任务标题",
          value: this.task.name,
          _type: "dataDetail"
        },
        {
          id: "verifyRoute",
          name: "任务路径",
          value: this.task.path
        },
        { id: "leader", name: "负责人", value: this.task.assigneeUser?.name },
        { id: "dueDate", name: "截止时间", value: this.task.dueDate },
        { id: "completeUser", name: "完成人", value: this.task.completerUser?.name },
        {
          id: "verifyResult",
          name: "审批结果",
          _type: "verifyResult",
          value: verifyResult
        }
      ]
    },
    verifyData() {
      if (this.verifyType === "task") return []
      let verifyResult = ""
      if (this._.keys(this.verifyItem).includes("pass")) {
        if (this.verifyItem.pass === true) verifyResult = "通过"
        else if (this.verifyItem.pass === false) verifyResult = "驳回"
      }
      if (this.verifyItem.status == "RECALLED") verifyResult = "撤回"
      return [
        {
          id: this.verifyItem.dataId,
          name: "审批数据",
          _type: "dataDetail",
          value: this.verifyItem.dataTitle
        },
        {
          id: "verifyRoute",
          name: "审批路径",
          value: this.verifyItem.dataPath || this.verifyItem.path
        },
        {
          id: "verifyUser",
          name: "提交人",
          value: this.verifyItem.user?.name
        },
        {
          id: "verifyResult",
          name: "审批结果",
          _type: "verifyResult",
          value: verifyResult
        }
      ]
    },
    promptTitle() {
      return `确认${this.pass ? "同意" : "驳回"}${this.verifyItem.name}么?`
    },
    dataOrder() {
      if (!this.verifyIds) return ""
      let index = this.verifyIds.indexOf(this.verifyItem.id)
      if (index == 0) return "first"
      else if (index == this.verifyIds.length - 1) return "last"
      return ""
    },
    hasEnd() {
      let lastItem = this._.last(this.allProcess)
      return this._.keys(lastItem).includes("pass")
    }
  },
  beforeCreate() {
    this.$options.components.SheetDetailDialog = require("@/components/Sheet/DetailDialog").default
    this.$options.components.TaskDetailDialog = require("@/components/Task/DetailDialog").default
  },
  methods: {
    openEvent() {
      this.setKeydown()
      getFrontSetting("todo").then(res => {
        if (this._.isBoolean(res?.verify?.dealNext)) this.dealNext = res.verify.dealNext
      })
      getFrontSetting(this.user.userId).then(res => {
        if (res?.sign) this.sign = res?.sign
      })
    },
    refreshOutside() {
      // 1.开始审批下一条时，不驳回或同意审批
      // 2.更换审批人
      // 直接关闭dialog需手动刷新列表
      if (
        (this.from === "todo" &&
          this.dealNext &&
          this.verifyIds.length > 1 &&
          this.dataOrder !== "last") ||
        this.lastOperation === "change_candidate"
      )
        this.$emit("task-verified")
    },
    async open(verifyItem, type, isNext = false) {
      this.sheetDefInfo = {}
      this.sheetDataInfo = {}
      this.curTab = { name: "" }
      this.verifyType = type
      this.verifyItem = verifyItem
      // 兼容老数据，没有设置acceptFillCids与rejectFillCids
      if (this._.isEmpty(this.verifyItem.acceptFillCids))
        this.verifyItem.acceptFillCids = [
          {
            cid: "verifyComments",
            type: "W",
            subList: []
          },
          {
            cid: "verifySign",
            type: "W",
            subList: []
          }
        ]
      if (this._.isEmpty(this.verifyItem.rejectFillCids))
        this.verifyItem.rejectFillCids = [
          {
            cid: "verifyComments",
            type: "H",
            subList: []
          },
          {
            cid: "verifySign",
            type: "R",
            subList: []
          }
        ]
      this.visible = true
      if (this.verifyType === "sheet") {
        this.sheetDataId = verifyItem.dataId
        this.appId = verifyItem.appId
        if (this.from === "todo") {
          this.sheetDataInfo = await getSheetDataForDetail({
            dataId: this.verifyItem.dataId,
            appId: this.verifyItem.appId
          })
          let sheetDefInfo = await getSheetDefForDetail(
            this.verifyItem.sheetId,
            this.verifyItem.dataId
          )
          this.sheetDefInfo = decorateSheet(sheetDefInfo)
        }
        Object.assign(this.dataInfo, { dataId: this.curSheetData.id, appId: this.appId })
      }
      if (this.verifyType === "task") {
        this.taskId = verifyItem.taskId
        if (this.from === "todo") {
          let res = await getTask(this.verifyItem.taskId)
          res.sheetData = res.sheetData || {}
          this.taskDataInfo = res
          if (this.taskDataInfo.taskType?.refSheetId) {
            this.sheetDefInfo = await getSheet(this.taskDataInfo.taskType?.refSheetId)
          }
          this.sheetDataInfo = this.taskDataInfo.sheetData
        }
      }
      this.allButton = await getVerifyButtonList(this.verifyItem.id)
      this.buttonList = this.getButton(this.allButton)
      await initUserData()
      this.allProcess = await getVerifyProcess(this.verifyItem.processInstanceId)
      this.verifyProcess = this.getDetailInfo(this.allProcess)
      this.tabs = this.getTabs()
      if (!isNext) {
        this.visible = true
      }
      if (this.verifyType === "sheet" && this.tabs.length) {
        this.selectMenu(this.tabs[0])
        this.$nextTick(() => this.$refs.sideMenu.init())
      }
    },
    getTabs() {
      return (
        this.curSheetDef.controls
          ?.filter(
            c =>
              c._type === "ref" &&
              !c.oneFlag &&
              this.verifyItem.verifyContents?.map(item => item.cid)?.includes(c._cid)
          )
          .map(c => {
            let dataIds = this.curSheetData.data[c._cid] || []
            return {
              name: `${c.name}（${dataIds.length}）`,
              sheetId: c.refSheetId,
              dataIds,
              cid: c._cid,
              related: c.related
            }
          }) || []
      )
    },
    setKeydown() {
      document.onkeydown = e => {
        let keyCode = e.keyCode || e.which || e.charCode
        let altKey = e.altKey
        if (altKey && keyCode === 37) {
          this.openData("previous")
        } else if (altKey && keyCode === 39) {
          this.openData("later")
        }
      }
    },
    getButton(buttonList) {
      let result = []
      buttonList.forEach(button => {
        switch (button) {
          case "verify":
            result.push({
              title: this.verifyItem.rejectButtonName,
              command: "reject",
              type: null,
              id: 4
            })
            result.push({
              title: this.verifyItem.acceptButtonName,
              command: "pass",
              type: "primary",
              id: 5
            })
            break
          case "recall":
            result.push({ title: "撤回审批", command: "recall", type: "text", id: 1 })
            break
          case "change_candidate":
            result.push({ title: "更换审批人", command: "change_candidate", type: "text", id: 2 })
            break
          case "preview":
            result.push({ title: "查看完整流程", command: "preview", type: "text", id: 3 })
            break
        }
      })
      return this._.sortBy(result, "id")
    },
    verify(pass) {
      this.pass = pass
      let showContent = this.getShowContent()
      if (showContent) this.$refs.verifyConfirmDialog.open(this.sign)
      else this.submit()
    },
    getShowContent() {
      if (this.pass) {
        let verifyComments = this.verifyItem.acceptFillCids.find(
          item => item.cid === "verifyComments"
        )
        let verifySign = this.verifyItem.acceptFillCids.find(item => item.cid === "verifySign")
        return !(
          verifyComments.type === "R" &&
          verifySign.type === "R" &&
          this.verifyItem.acceptFillCids.length === 2
        )
      } else {
        let rejectHiddenList =
          this.verifyItem.rejectFillCids.filter(item => item.type === "R") || []
        return rejectHiddenList.length !== 2
      }
    },
    submit(value, sign, form) {
      let loading = loadingService()
      TaskApi.verifyTask({
        verifyRecordId: this.verifyItem.id,
        pass: this.pass,
        comment: value,
        signId: sign?.id,
        form: form
      })
        .then(() => {
          this.$message.success("处理成功")
          if (sign && this.sign?.id !== sign?.id) {
            this.sign = sign
            setFrontSetting(this.sign, this.user.userId, "sign")
          }
          if (this.from === "todo" && this.dealNext && this.verifyIds.length > 1) {
            this.openData("later")
            if (this.dataOrder === "last") {
              this.$emit("task-verified")
              this.visible = false
            }
          } else {
            this.$emit("task-verified")
            this.visible = false
          }
        })
        .finally(() => loading.close())
    },
    getValue(cid, type) {
      let commonMap = {
        createAt: this.curSheetData.createAt,
        creator: this.curSheetData.creator?.name,
        updateUser: this.curSheetData.updateUser?.name,
        updateAt: this.curSheetData.updateAt,
        owner: this.curSheetData.owner?.name,
        project: this.curSheetData.projectName
      }
      if (commonMap[cid] !== undefined) return commonMap[cid]
      return type === "string" ? this.curSheetData.dataForShow[cid] : this.curSheetData.data[cid]
    },
    handleCommand(btn) {
      this.lastOperation = btn
      switch (btn) {
        case "reject":
          this.verify(false)
          break
        case "pass":
          this.verify(true)
          break
        case "recall":
          this.recall()
          break
        case "change_candidate":
          this.$refs.candidatesDialog.open(this.verifyItem.candidateUserIds)
          break
        case "preview":
          this.previewProcess()
          break
      }
    },
    recall() {
      this.$confirm("是否撤回审批?", "撤回", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(() => {
        let loading = loadingService()
        let taskId = this.verifyType === "sheet" ? null : this.task.id
        TaskApi.recallTask(taskId, this.verifyItem?.id)
          .then(() => {
            this.$message.success("撤回成功")
            this.visible = false
            this.$emit("task-verified")
          })
          .finally(() => loading.close())
      })
    },
    changeCandidates(items) {
      let loading = loadingService()
      TaskApi.changeCandidateUsers(this.verifyItem.id, items)
        .then(() => {
          this.verifyItem.candidateUserIds = items
          this.$message.success("更改审核人成功")
          this.open(this.verifyItem, this.verifyType, true)
        })
        .finally(() => loading.close())
    },
    previewProcess() {
      let id = this.verifyType === "sheet" ? this.verifyItem.workflow.id : this.task.workflowId
      const { href } = this.$router.resolve({
        name: "process-preview",
        query: { id: id }
      })
      window.open(href, "_blank")
    },
    openDataDetail() {
      if (this.verifyType === "sheet") this.sheetDetailVisible = true
      else this.taskDetailVisible = true
    },
    openData(direction) {
      let verifyId = ""
      let index = this.verifyIds.indexOf(this.verifyItem.id)
      if (direction == "previous") {
        if (this.dataOrder !== "first") {
          verifyId = this.verifyIds[index - 1]
        } else {
          this.$message.info("已经是第一条数据")
        }
      } else if (direction == "later") {
        if (this.dataOrder !== "last") {
          verifyId = this.verifyIds[index + 1]
        } else {
          this.$message.info("已经是最后一条数据")
        }
      }
      if (!verifyId) return
      this.$emit("turnVerify", verifyId)
    },
    selectMenu(menu) {
      this.curTab = menu
      this.getRefControl()
    },
    getRefControl() {
      let refControlInfo = this.verifyItem.verifyContents?.find(
        item => item.cid === this.curTab.cid
      )
      let fields = refControlInfo.subList?.map(item => item.cid) || []
      this.refControl = Object.assign({}, this.cidControlMap[this.curTab.cid], { fields: fields })
    },
    setDealNext(val) {
      setFrontSetting({ dealNext: this.dealNext }, "todo", "verify")
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-sheet-data-dialog {
  .body-wrapper {
    height: 600px;
    .el-collapse {
      padding: 10px 0;
      border: none;
      .verify-content {
        width: 100%;
        .data-detail {
          display: flex;
          flex-wrap: wrap;
        }
        .ref-table {
          .ref-menu {
            margin-top: 20px;
          }
          .content-body {
            display: flex;
            flex-flow: column;
            flex: auto;
            box-sizing: border-box;
            padding-right: 20px;
            height: 210px;
            .sheet-table-wrap {
              flex: 1;
              overflow: hidden;
              display: flex;
              flex-flow: column;
              background-color: #fff;
              &.full-screen {
                padding: 0;
                .operation {
                  padding: 10px 20px;
                  padding-left: 20px;
                }
              }
              .operation {
                display: flex;
                margin-bottom: 6px;
                position: relative;
                z-index: 100;
                .sheet-name {
                  margin-left: 20px;
                  margin-right: 20px;
                  position: relative;
                  line-height: 28px;
                  &:before {
                    content: "";
                    position: absolute;
                    left: -20px;
                    width: 6px;
                    height: 28px;
                    border-radius: 4px;
                    background-color: #1989fa;
                  }
                }
              }
              .ref-button-group {
                margin-left: auto;
                span {
                  font-size: $font-size-main;
                  height: 28px;
                  line-height: 28px;
                  color: $color-main;
                  cursor: pointer;
                  &:hover {
                    color: #66b1ff;
                  }
                  & + span {
                    margin-left: 10px;
                  }
                }
              }
              .sheet-table {
                flex: auto;
                overflow: hidden;
              }
            }
          }
        }
      }
      .process {
        margin-left: 12px;
        width: 100%;
        line-height: 1.35;
        ::v-deep {
          .detail-content {
            border-bottom: none;
          }
          .staff {
            background-color: #fff;
          }
          .process-advice {
            width: 586px;
          }
          .advice {
            width: 586px;
          }
        }
      }
      .has-end {
        ::v-deep {
          .el-divider--vertical {
            height: calc(100% - 20px);
          }
        }
      }
      .no-end {
        ::v-deep {
          .el-divider--vertical {
            height: calc(100% - 60px);
          }
        }
      }
      ::v-deep {
        .pagination-wrapper {
          border-left: unset;
        }
        .el-collapse-item {
          position: relative;
          &.hide-last2 .field-item:nth-last-child(2) {
            border-bottom: none;
          }
          &::before {
            content: "";
            position: absolute;
            top: 6px;
            width: 4px;
            height: 18px;
            border-radius: 4px;
            background-color: #1989fa;
          }
        }
        .el-collapse-item + .el-collapse-item {
          margin-top: 10px;
        }
        .el-collapse-item.is-active + .el-collapse-item {
          margin-top: 20px;
        }
        .el-collapse-item__header,
        .el-collapse-item__wrap {
          border-bottom: none;
        }
        .el-collapse-item__header,
        .el-collapse-item__content {
          color: $color-font-title;
        }
        .el-collapse-item__header {
          margin-left: 10px;
          height: 30px;
          line-height: 30px;
          font-size: $font-size-main;
          font-weight: bold;
          .el-collapse-item__arrow {
            margin-left: 10px;
            color: $color-font-second;
          }
        }
        .el-collapse-item__content {
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 0;
          .field-item {
            box-sizing: border-box;
            border-bottom: 1px solid #e4e4e4;
            &:nth-child(odd) {
              margin-right: 20px;
              width: calc(50% - 20px);
            }
            &:nth-child(even) {
              width: 50%;
            }
            .label {
              width: 80px;
              min-width: 60px;
            }
          }
        }
      }
      .tip {
        padding-left: 20px;
        .tip-item {
          list-style: disc;
        }
      }
    }
  }
  .verify-operation {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
  }
  ::v-deep .el-dialog {
    height: 600px;
    .icon-turn-page {
      font-size: 16px;
      padding: 3px;
      color: $color-font-second;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        color: $color-main;
      }
      &:first-of-type {
        padding-right: 0;
      }
      &:last-of-type {
        padding-left: 0;
      }
      &.is-disabled {
        color: $color-font-third;
        cursor: not-allowed;
      }
    }
  }
}
</style>
